import axios from "axios";
import { WordpressOmroep } from "../../types/wordpressTypes/wordpressOmroep";
import { primeMediaUrlsFromEntities } from "../apiFunctions/mediaUrls";

export async function fetchOmroep(omroep: string) {
  const result = await axios.get<WordpressOmroep[]>(`${import.meta.env.VITE_API_URL}/wp-json/wp/v2/tv-channel?slug=${omroep}`);
  primeMediaUrlsFromEntities(result.data);
  return result.data?.[0];
}
